// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__2vuw2","ScrollX":"Scroll_ScrollX__16Sui","ScrollY":"Scroll_ScrollY__3F1AW"};